import React, { useEffect, useRef, useState } from "react";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import api from "../../../api";
import { useFormik } from "formik";
import * as Yup from "yup";
import { ProgressSpinner } from "primereact/progressspinner";
import { Toast } from "primereact/toast";
import { InputTextarea } from "primereact/inputtextarea";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Calendar } from "primereact/calendar";
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';


const UserMaster = () => {
  const currentDate1 = new Date();
  const formattedCurrentDate = `${currentDate1.getDate().toString().padStart(2, '0')}-${(currentDate1.getMonth() + 1).toString().padStart(2, '0')}-${currentDate1.getFullYear()} ${currentDate1.getHours().toString().padStart(2, '0')}:${currentDate1.getMinutes().toString().padStart(2, '0')}:${currentDate1.getSeconds().toString().padStart(2, '0')}`;

  const userID = sessionStorage.getItem("UserID");
  const roleID = sessionStorage.getItem("RoleID");
  const stateID = sessionStorage.getItem("stateID");
  const stateName = sessionStorage.getItem("stateName");
  const dt = useRef(null);

  const [loading, setLoading] = useState(false);
  const toast = useRef(null);

  const getUserData = async () => {
    try {
      const requestData = {
        logged_in_userid: userID,
        role_id: roleID,
        state_id: "",
        synceddatetime: formattedCurrentDate,
        FormCode: "214",
        ApiKey: "kavin",
        AppTypeNo: "3",
        AppVersion: "1.0.0",
        data_source: "W",
      };
  
      const result = await api.get_User_Data(requestData);
  
      // State Data
      const stateData = result.phc_details.map((state) => ({
        label: state.fld_state_name,
        value: state.fld_state_name,
        state_code: state.fld_state_id,
        state_swid: state.fld_state_sw_id,
      }));
      setState(stateData);
  
      // District Data
      const distData = result.phc_details.map((district) => ({
        label: district.fld_district_name,
        value: district.fld_district_name,
        district_code: district.fld_district_id,
        district_swid: district.fld_district_sw_id,
      }));
      setDistrict(distData);
  
      // Site Data
      const siteData = result.phc_details.map((site) => ({
        label: site.fld_site_name,
        value: site.fld_site_name,
        site_code: site.fld_site_id,
        site_swid: site.fld_site_sw_id,
      }));
      setSite(siteData);
  
      if (roleID === "2") {
        // Prebind State
        const currentState = stateData.find(
          (stateObj) => stateObj.value === result.phc_details[0].fld_state_name
        );
        setSelectedState(currentState);
        formik.setFieldValue("state_name", currentState?.value || "");
        formik.setFieldValue("state_code", currentState?.state_code || "");
        formik.setFieldValue("state_sw_id", currentState?.state_swid || "");
  
        // Prebind District
        const currentDist = distData.find(
          (distObj) => distObj.value === result.phc_details[0].fld_district_name
        );
        setSelectedDistrict(currentDist);
        formik.setFieldValue("district_name", currentDist?.value || "");
        formik.setFieldValue("district_code", currentDist?.district_code || "");
        formik.setFieldValue("district_sw_id", currentDist?.district_swid || "");
  
        // Prebind Site
        const currentSite = siteData.find(
          (siteObj) => siteObj.value === result.phc_details[0].fld_site_name
        );
        setSelectedSite(currentSite);
        formik.setFieldValue("site_name", currentSite?.value || "");
        formik.setFieldValue("site_code", currentSite?.site_code || "");
        formik.setFieldValue("site_swid", currentSite?.site_swid || "");

        if (roleID === "2") {
        
          getTaluk(
            currentState?.state_code,
            currentState?.state_swid,
            currentDist?.district_code,
            currentDist?.district_swid,
            currentSite?.site_code,
            currentSite?.site_swid
          );
        }        }
    } catch (error) {
      console.error("Error fetching state:", error);
    }
  };
  
    useEffect(() => {
      if (roleID === "2") {
        getUserData();
      }
    }, [roleID]);


  const [selectedState, setSelectedState] = useState({ state_code: "" });
  const [selectedDistrict, setSelectedDistrict] = useState({ district_code: ""});
  const [selectedSite, setSelectedSite] = useState({ site_code: "" });
  const [selectedTaluk, setSelectedTaluk] = useState({ taluk_code: "" });
  const [selectedVillage, setSelectedVillage] = useState({ village_code: "" });
  const [selectedPHC, setSelectedPHC] = useState({ phc_code: "" });
  const [selectedReportingPRS, setSelectedReportingPRS] = useState({prs_code: "",});
  const [selectedReplacedUser, setSelectedReplacedUser] = useState({rUser_code: "",});
  const [selectedRole, setSelectedRole] = useState("");
  const [selectedGender, setSelectedGender] = useState("");
  const [selectedIsReplaced, setSelectedIsReplaced] = useState("");
  const [editRow, setEditRow] = useState(false);


  const roleNames = roleID === "2"
  ? [
      { id: "3", label: "PRS" },
      { id: "4", label: "HCW" },
    ]
  : [
      { id: "2", label: "Site Admin" },
      { id: "3", label: "PRS" },
      { id: "4", label: "HCW" },
    ];

  const genderNames = [
    { id: "1", label: "Male" },
    { id: "2", label: "Female" },
  ];

  const isReplaced = [
    { id: "1", label: "Yes" },
    { id: "2", label: "No" },
  ];


  const [date, setDate] = useState(null);
  const minDate = new Date('2021-01-01');
  const today = new Date();
  const maxDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());



  const [state, setState] = useState([]);
  const getStates = async () => {
    try {
      const requestData = {
        logged_in_userid: userID,
        synceddatetime: formattedCurrentDate,
        FormCode: "202",
        ApiKey: "kavin",
        AppTypeNo: "3",
        AppVersion: "1.0.0",
        data_source: "W",
      };

      const result = await api.get_States(requestData);
      const statesData = result.geo_master_state.map((state) => ({
        label: state.fld_state_name,
        value: state.fld_state_name,
        state_code: state.fld_state_id,
        state_swid: state.fld_state_sw_id,
      }));
      setState(statesData);
    } catch (error) {
      console.error("Error fetching state:", error);
    }
  };

  const [district, setDistrict] = useState([]);
  const getDistrict = async (state_id, state_sw_id) => {
    try {
      const requestData = {
        logged_in_userid: userID,
        state_sw_id,
        state_id,
        synceddatetime: formattedCurrentDate,
        FormCode: "202",
        ApiKey: "kavin",
        AppTypeNo: "3",
        AppVersion: "1.0.0",
        data_source: "W",
      };

      const result = await api.get_District(requestData);
      const districtData = result.geo_master_district.map((district) => ({
        label: district.fld_district_name,
        value: district.fld_district_name,
        district_code: district.fld_district_id,
        district_swid: district.fld_district_sw_id,
      }));
      setDistrict(districtData);
    } catch (error) {
      console.error("Error fetching district:", error);
    }
  };

  const [site, setSite] = useState([]);
  const getSite = async (
    state_id,
    state_sw_id,
    district_id,
    district_sw_id
  ) => {
    try {
      const requestData = {
        logged_in_userid: userID,
        state_id,
        state_sw_id,
        district_id,
        district_sw_id,
        synceddatetime: formattedCurrentDate,
        FormCode: "202",
        ApiKey: "kavin",
        AppTypeNo: "3",
        AppVersion: "1.0.0",
        data_source: "W",
      };

      const result = await api.get_Site(requestData);
      const siteData = result.geo_master_site.map((site) => ({
        label: site.fld_site_name,
        value: site.fld_site_name,
        site_code: site.fld_site_id,
        site_swid: site.fld_site_sw_id,
      }));
      setSite(siteData);
    } catch (error) {
      console.error("Error fetching district:", error);
    }
  };

  const [taluk, setTaluk] = useState([]);
  const getTaluk = async (
    state_id,
    state_sw_id,
    district_id,
    district_sw_id,
    site_id,
    site_sw_id
  ) => {
    try {
      const requestData = {
        logged_in_userid: userID,
        state_sw_id,
        state_id,
        district_sw_id,
        district_id,
        site_sw_id,
        site_id,
        synceddatetime: formattedCurrentDate,
        FormCode: "202",
        ApiKey: "kavin",
        AppTypeNo: "3",
        AppVersion: "1.0.0",
        data_source: "W",
      };

      const result = await api.get_Taluk(requestData);
      const talukData = result.geo_master_taluk.map((taluk) => ({
        label: taluk.fld_taluk_name,
        value: taluk.fld_taluk_name,
        taluk_code: taluk.fld_taluk_id,
        taluk_swid: taluk.fld_taluk_sw_id,
      }));
      setTaluk(talukData);
    } catch (error) {
      console.error("Error fetching district:", error);
    }
  };

  const [village, setVillage] = useState([]);
  const getVillage = async (
    state_id,
    state_sw_id,
    district_id,
    district_sw_id,
    site_id,
    site_sw_id,
    taluk_id,
    taluk_sw_id
  ) => {
    try {
      const requestData = {
        logged_in_userid: userID,
        state_sw_id,
        state_id,
        district_sw_id,
        district_id,
        site_sw_id,
        site_id,
        taluk_sw_id,
        taluk_id,
        synceddatetime: formattedCurrentDate,
        FormCode: "202",
        ApiKey: "kavin",
        AppTypeNo: "3",
        AppVersion: "1.0.0",
        data_source: "W",
      };

      const result = await api.get_Village(requestData);
      const villageData = result.geo_master_village.map((village) => ({
        label: village.fld_village_name,
        value: village.fld_village_name,
        village_code: village.fld_village_id,
        village_swid: village.fld_village_sw_id,
      }));
      setVillage(villageData);
    } catch (error) {
      console.error("Error fetching district:", error);
    }
  };

  const [phc, setPhc] = useState([]);
  const getPHC = async (
    state_id,
    state_sw_id,
    district_id,
    district_sw_id,
    site_id,
    site_sw_id,
    taluk_id,
    taluk_sw_id,
    village_sw_id,
    village_id
  ) => {
    try {
      const requestData = {
        logged_in_userid: userID,
        state_sw_id,
        state_id,
        district_sw_id,
        district_id,
        site_sw_id,
        site_id,
        taluk_sw_id,
        taluk_id,
        village_sw_id,
        village_id,
        synceddatetime: formattedCurrentDate,
        FormCode: "202",
        ApiKey: "kavin",
        AppTypeNo: "3",
        AppVersion: "1.0.0",
        data_source: "W",
      };

      const result = await api.get_PHC(requestData);
      // console.log("PHC", result);
      const phcData = result.geo_master_phc.map((phc) => ({
        label: phc.fld_phc_name,
        value: phc.fld_phc_name,
        phc_code: phc.fld_phc_id,
        phc_swid: phc.fld_phc_sw_id,
        phc_type_id: phc.fld_phc_type_id,
        phc_type_name: phc.fld_phc_type_name,

      }));
      setPhc(phcData);
    } catch (error) {
      console.error("Error fetching district:", error);
    }
  };

  const [reportingPRS, setReportingPRS] = useState([]);
  const getReportingPRS = async (
    state_id,
    state_sw_id,
    district_id,
    district_sw_id,
    site_id,
    site_sw_id,
    taluk_id,
    taluk_sw_id,
    village_sw_id,
    village_id
  ) => {
    try {
      const requestData = {
        role_id: "4",
        logged_in_userid: userID,
        site_id,
        taluk_id,
        village_id,
        synceddatetime: formattedCurrentDate,
        FormCode: "202",
        ApiKey: "kavin",
        AppTypeNo: "3",
        AppVersion: "1.0.0",
        data_source: "W",
      };

      const result = await api.get_Reporting_PRS(requestData);
      // console.log("PRS", result);
      const prsData = result.reporting_prs.map((prs) => ({
        label: prs.fld_user_name,
        value: prs.fld_user_name,
        reporting_prs_code: prs.fld_user_sw_id,
      }));
      setReportingPRS(prsData);
    } catch (error) {
      console.error("Error fetching district:", error);
    }
  };

  const [replacedUser, setReplacedUser] = useState([]);
  const getReplacedUser = async () => {
    try {
      const requestData = {
        fld_loggedin_user_id: userID,
        fld_role_id: selectedRole?.id || "", // Pass selected role ID
        fld_role_name: selectedRole?.label || "", // Pass selected role name
        fld_phc_id: selectedPHC?.phc_code || "", // Pass selected PHC code
        fld_phc_name: selectedPHC?.value || "", // Pass selected PHC name
        fld_phc_type_id: selectedPHC?.phc_type_id || "", // Optional: Pass PHC type ID
        fld_phc_type_name: selectedPHC?.phc_type_name || "", // Optional: Pass PHC type name
        synceddatetime: formattedCurrentDate,
        FormCode: "202",
        ApiKey: "kavin",
        AppTypeNo: "3",
        AppVersion: "1.0.0",
        data_source: "W",
      };

      const result = await api.get_Replaced_User(requestData);
      const prsData = result.inactive_users.map((prs) => ({
        label: prs.fld_user_name,
        value: prs.fld_user_name,
        rUser_ID: prs.fld_user_id,
        rUser_code: prs.fld_user_code,
        rUser_swid: prs.fld_user_sw_id,
        rUser_rfID: prs.fld_rf_id,
        rUser_pass: prs.fld_password
      }));
      setReplacedUser(prsData);
    } catch (error) {
      console.error("Error fetching district:", error);
    }
  };

  const [usersList, setUsersList] = useState([]);
  const fetchUsersList = async () => {
    try {
      setLoading(true);
      const requestData = {
        role_id: roleID,
        logged_in_userid: userID,
        state_id : stateID || "",
        synceddatetime: formattedCurrentDate,
        FormCode: "201",
        ApiKey: "kavin",
        AppTypeNo: "3",
        AppVersion: "1.0.0",
        data_source: "W",
      };
      const result = await api.get_Created_Users(requestData);
        const responseData = result.registered_user_by_admin;
        const slNo = responseData.map((item, index) => ({
                   ...item, slno: index + 1
               }));
        setUsersList(slNo);
    } catch (error) {
      console.error("Error fetching requested data:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchUsersList();
  }, []);


    const [globalFilter, setGlobalFilter] = useState('');
  
    const onFilterInputChange = (e) => {
      setGlobalFilter(e.target.value);
    };
    const filteredData = usersList.filter((role) =>
    Object.values(role).some((value) => {
      if (value === null || value === undefined) {
        return false;
      }
      return value.toString().toLowerCase().includes(globalFilter.toLowerCase());
    })
  );
  
    const header = () => {
      return (
              <IconField iconPosition="left">
                <InputIcon className="pi pi-search">
                </InputIcon>
                <InputText value={globalFilter} onChange={onFilterInputChange} placeholder="Search" />
              </IconField>
      );
  };


  const formik = useFormik({
    initialValues: {
      date: "",
      fld_role_id: "",
      fld_role_name: "",
      state_name: "",
      district_name: "",
      site_name: "",
      taluk_name: "",
      village_name: "",
      phc_name: "",
      fld_user_name: "",
      fld_age: "",
      fld_mobile_number: "",
      fld_gender_name: "",
      fld_email_id: "",
      fld_abha_id: "",
      fld_address: "",
      fld_reporting_prs_name: "",
      fld_is_replaced_name: "",
      fld_replaced_user_name: "",
      fld_date_of_leaving:"",
      fld_reason_for_leaving:""
    },
    validationSchema: () => {
      let schema = Yup.object({
        date: Yup.string().required("Date is required"),
        fld_role_name: Yup.string().required("Role name is required"),
        state_name: Yup.string().required("State is required"),
        district_name: Yup.string().required("District Name is required"),
        site_name: Yup.string().required("Site Code is required"),
        taluk_name: Yup.string().required("Taluk Name is required"),
        village_name: Yup.string().required("Village Name is required"),
        phc_name: Yup.string().required("PHC Name is required"),
        fld_user_name: Yup.string().required("User Name is required"),
        fld_age:  Yup.number().required("Age is required").integer("Please enter a valid integer")
                  .min(18, "Age must be at least 18")
                  .max(99, "Age must be at most 99"),
        fld_mobile_number: Yup.string()
                          .matches(/^[6-9]\d{9}$/, 'Mobile Number must start with 6, 7, 8, or 9 and be 10 digits long')
                          .required("Phone number is required"),
        fld_gender_name: Yup.string().required("Gender is required"),
        fld_email_id: Yup.string(),
        fld_abha_id: Yup.string().matches(/^[0-9]{14}$/, "ABHA ID must be exactly 14 digits"),
        fld_address: Yup.string(),
        fld_is_replaced_name: Yup.string(),
        fld_date_of_leaving: Yup.date().nullable(),
        // fld_reason_for_leaving: Yup.string().when("fld_date_of_leaving", {
        //   is: (date) => !!date, // Checks if date exists
        //   then: (schema) => schema.required("Reason for leaving is required"),
        // }),
      });
      if (selectedRole && selectedRole.id === "4") {
        schema = schema.shape({
          fld_reporting_prs_name: Yup.string().required("Reporting PRS is required"),
        });
      }
      if (selectedIsReplaced && selectedIsReplaced.id === "1") {
        schema = schema.shape({
          fld_replaced_user_name: Yup.string().required("Replaced User Name is required"),
        });
      }
      if (formik.values.fld_date_of_leaving) {
        schema = schema.shape({
          fld_reason_for_leaving: Yup.string().required("Reason for leaving is required"),
        });
      }
      // if (formik.values.fld_date_of_leaving) {
      //   toast.current.show({
      //     severity: "info",
      //     summary: "Field missing",
      //     detail: "Reason for leaving is required Field required"
      // });
      // }
      return schema;
    },


    onSubmit: async (values, { resetForm }) => {
      try {
        setLoading(true);
        const additionalData = {
          create_user_details: [
            {
              // fld_rf_id: values.fld_rf_id || "",
              // fld_rf_id: values.fld_rf_id ? Number(values.fld_rf_id) : "",
              fld_rf_id: values.fld_rf_id ? values.fld_rf_id.toString() : "" ,

              fld_state_sw_id: selectedState?.state_swid || values.fld_state_sw_id,
              fld_state_id: selectedState?.state_code || values.fld_state_id,
              fld_state_name: values.state_name,
              fld_district_sw_id: selectedDistrict?.district_swid || values.fld_district_sw_id,
              fld_district_id: selectedDistrict?.district_code || values.fld_district_id,
              fld_district_name: values.district_name,
              fld_site_id: selectedSite?.site_code || values.fld_site_id,
              fld_site_sw_id: selectedSite?.site_swid || values.fld_site_sw_id,
              fld_site_name: values.site_name,
              fld_taluk_sw_id: selectedTaluk?.taluk_swid || values.fld_taluk_sw_id,
              fld_taluk_id: selectedTaluk?.taluk_code || values.fld_taluk_id,
              fld_taluk_name: values.taluk_name,
              fld_village_sw_id: selectedVillage?.village_swid || values.fld_village_sw_id,
              fld_village_id: selectedVillage?.village_code || values.fld_village_id,
              fld_village_name: values.village_name,
              fld_phc_type_id: selectedPHC?.phc_type_id || values.fld_phc_type_id,
              fld_phc_type_name: selectedPHC?.phc_type_name || values.fld_phc_type_name,
              fld_phc_sw_id: selectedPHC?.phc_swid || values.fld_phc_sw_id,
              fld_phc_id: selectedPHC?.phc_code || values.fld_phc_id,
              fld_phc_name: values.phc_name,
              fld_role_id: values.fld_role_id,
              fld_role_name: values.fld_role_name,
              fld_user_sw_id: values.fld_user_sw_id || "",
              fld_user_id: values.fld_user_id || "",
              fld_password: values.fld_password || "",
              fld_user_name: values.fld_user_name,
              fld_user_code: values.fld_user_code || "",
              fld_gender_id: values.fld_gender_id,
              fld_gender_name: values.fld_gender_name,
              fld_age: values.fld_age,
              fld_abha_id: values.fld_abha_id,
              fld_email_id: values.fld_email_id,
              fld_mobile_number: values.fld_mobile_number,
              fld_address: values.fld_address,
              fld_reporting_prs_sw_id : selectedReportingPRS?.reporting_prs_code || values.fld_reporting_prs_sw_id,
              fld_reporting_prs_name: values.fld_reporting_prs_name,
              fld_date_of_joining: values.date.toLocaleDateString("en-GB"),
              fld_date_of_leaving: values.fld_date_of_leaving instanceof Date ?
                                   values.fld_date_of_leaving.toLocaleDateString("en-GB")  : "",
              fld_reason_for_leaving: values.fld_reason_for_leaving || "",
              fld_is_replaced_id : values.fld_is_replaced_id || "0",
              fld_is_replaced_name : values.fld_is_replaced_name || "",
              fld_replaced_user_name: values.fld_replaced_user_name || "",
              fld_db_version :  "1.0",
              fld_data_source :  "Web",
              fld_loggedin_user_id: userID,
              fld_is_active: values.fld_date_of_leaving ? "0" : "1", 
              fld_is_deleted: values.fld_date_of_leaving ? "1" : "0", 

            },
          ],
          synceddatetime: formattedCurrentDate,
          FormCode: "202",
          ApiKey: "kavin",
          AppTypeNo: "3",
          AppVersion: "1.0.0",
          data_source: "W",
        };
        const response = await api.add_User(additionalData);

        if (response && response.status === "1") {
          resetForm();
          setEditRow(false);

          setSelectedRole(null);
          setSelectedGender(null);
          setSelectedIsReplaced(null)
          setSelectedState([])
          setSelectedDistrict([])
          setSelectedSite([])
          fetchUsersList();
          if (roleID === "2") {
            getUserData();
        }
          toast.current.show({
            severity: "success",
            summary: "User Created Successful",
            detail:
              response.responsemessage ||
              "You have successfully created the User.",
          });

          // getAllLocation();
        } else {
          throw new Error(
            response
              ? response.responsemessage ||
                "An error occurred while creating the PHC."
              : "No response from the server."
          );
        }
      } catch (error) {
        console.error("PHC submission error:", error);

        // Extract the response message if it exists
        const errorMessage =
          error.response?.data?.responsemessage || // Check for server-provided responsemessage
          error.message || // Fallback to JavaScript error message
          "An unexpected error occurred. Please try again."; // Default fallback message
      
        toast.current.show({
          severity: "error",
          summary: "PHC Failed",
          detail: errorMessage, // Show the extracted error message
        });
      } finally {
        setLoading(false);
      }
    },
  });

const [originalHasDate, setOriginalHasDate] = useState(false);

const editUser = async (userData) => {
  // console.log(userData)
  setEditRow(true);

  const hasDate = !!userData.fld_date_of_joining;
  setOriginalHasDate(hasDate);
  try {
    setLoading(true);

    formik.setValues({
      fld_rf_id: userData.fld_rf_id || "",
      fld_role_name: userData.fld_role_name || "",
      fld_role_id: userData.fld_role_id || "",
      state_name: userData.fld_state_name || "",
      district_name: userData.fld_district_name || "",
      site_name: userData.fld_site_name || "",
      taluk_name: userData.fld_taluk_name || "",
      village_name: userData.fld_village_name || "",
      phc_name: userData.fld_phc_name || "",
      fld_user_name: userData.fld_user_name || "",
      fld_age: userData.fld_age || "",
      fld_mobile_number: userData.fld_mobile_number || "",
      fld_gender_name: userData.fld_gender_name || "",
      fld_email_id: userData.fld_email_id || "",
      fld_abha_id: userData.fld_abha_id || "",
      fld_address: userData.fld_address || "",
      fld_reporting_prs_name: userData.fld_reporting_prs_name || "",
      fld_reporting_prs_sw_id: userData.fld_reporting_prs_sw_id || "",
      fld_state_id: userData.fld_state_id || "",
      fld_state_sw_id: userData.fld_state_sw_id || "",
      fld_district_id: userData.fld_district_id || "",
      fld_district_sw_id: userData.fld_district_sw_id || "",
      fld_site_id: userData.fld_site_id || "",
      fld_site_sw_id: userData.fld_site_sw_id || "",
      fld_taluk_id: userData.fld_taluk_id || "",
      fld_taluk_sw_id: userData.fld_taluk_sw_id || "",
      fld_village_id: userData.fld_village_id || "",
      fld_village_sw_id: userData.fld_village_sw_id || "",
      fld_phc_id: userData.fld_phc_id || "",
      fld_phc_sw_id: userData.fld_phc_sw_id || "",
      fld_phc_type_name: userData.fld_phc_type_name || "",
      fld_phc_type_id: userData.fld_phc_type_id || "",
      fld_user_sw_id: userData.fld_user_sw_id || "",
      fld_gender_id: userData.fld_gender_id || "",
      fld_user_id: userData.fld_user_id || "",
      fld_password: userData.fld_password || "",
      fld_user_code: userData.fld_user_code || "",
    date: hasDate
      ? new Date(userData.fld_date_of_joining.split("/").reverse().join("-"))
      : null,
        // fld_is_active : 0
    });
    

    const role_id = userData.fld_role_id || "";
    const site_id = userData.fld_site_id || "";
    const village_id = userData.fld_village_id || "";

    const payload = {
      logged_in_userid: userID,
      state_sw_id: userData.fld_state_sw_id,
      state_id: userData.fld_state_id,
      district_sw_id: userData.fld_district_sw_id,
      district_id: userData.fld_district_id,
      site_sw_id: userData.fld_site_sw_id,
      site_id,
      taluk_sw_id: userData.fld_taluk_sw_id,
      taluk_id: userData.fld_taluk_id,
      village_sw_id: userData.fld_village_sw_id,
      village_id,
      role_id,
      synceddatetime: formattedCurrentDate,
      FormCode: "202",
      ApiKey: "kavin",
      AppTypeNo: "3",
      AppVersion: "1.0.0",
      data_source: "W",
    };

    const [statedata, districtData, siteData, talukData, villageData, phcData, reportingPRSData] = await Promise.all([
      getStates(payload.logged_in_userid),
      getDistrict(payload.state_id, payload.state_sw_id),
      getSite(payload.state_id, payload.state_sw_id, payload.district_id, payload.district_sw_id),
      getTaluk(payload.state_id, payload.state_sw_id, payload.district_id, payload.district_sw_id, payload.site_id, payload.site_sw_id),
      getVillage(payload.state_id, payload.state_sw_id, payload.district_id, payload.district_sw_id, payload.site_id, payload.site_sw_id, payload.taluk_id, payload.taluk_sw_id),
      getPHC(payload.state_id, payload.state_sw_id, payload.district_id, payload.district_sw_id, payload.site_id, payload.site_sw_id, payload.taluk_id, payload.taluk_sw_id, payload.village_id, payload.village_sw_id),
      getReportingPRS(payload.state_id, payload.state_sw_id, payload.district_id, payload.district_sw_id, payload.site_id, payload.site_sw_id, payload.taluk_id, payload.taluk_sw_id, payload.village_id, payload.village_sw_id), // Make sure correct values are passed
    ]);

    statedata && setState(statedata);
    districtData && setDistrict(districtData);
    siteData && setSite(siteData);
    talukData && setTaluk(talukData);
    villageData && setVillage(villageData);
    phcData && setPhc(phcData);
    reportingPRSData && setReportingPRS(reportingPRSData);

    // console.log("✅ All geo data and Reporting PRS data successfully fetched and bound.");
  } catch (error) {
    console.error("❌ Error fetching geo data:", error);
  } finally {
    setLoading(false);
  }

  const selectedGender = genderNames.find((g) => g.label === userData.fld_gender_name);
  const selectedRole = roleNames.find((g) => g.label === userData.fld_role_name);
  setSelectedGender(selectedGender || null);
  setSelectedRole(selectedRole || null);
  
};



  const actionBodyTemplate = (rowData) => {
    return (
              <i
        className="pi pi-pencil"
        style={{ cursor: "pointer" }}
        onClick={() => editUser(rowData)}
      />
    );
  };

  return (
    <div>
      <Toast ref={toast} position="top-right" />
      {loading && (
        <div className="backdrop">
          <ProgressSpinner
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
            }}
          />
        </div>
      )}
      <form onSubmit={formik.handleSubmit}>

     <div className="pb-4" style={{border:"1px solid #c2c2c2", borderRadius:"10px", boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)"}}>
      <div className="grid flex align-items-baseline mt-3 ml-8">
          <div className="col-6 p-0">
            <div className="formslabel">Date of joining</div>
            <Calendar
              id="date"
              name="date"
              placeholder="Date of joining"
              value={formik.values.date}
              onChange={(e) => {
                const selectedDate = e.value instanceof Date ? e.value : new Date(e.value);
                formik.setFieldValue("date", selectedDate);
              }}
              showIcon
              className={
                formik.errors.date && formik.touched.date
                      ? "p-invalid p-inputtext forminputtext-invalid"
                      : "p-inputtext forminputtext"
              }
              dateFormat="dd/mm/yy"
              style={{border:"none"}}
              minDate={minDate}
              maxDate={maxDate}
                disabled={editRow && originalHasDate}

            />
            {formik.errors.date && formik.touched.date && (
              <span className="p-error mt-1" style={{ fontSize: "12px" }}>
                {formik.errors.date}
              </span>
            )}
          </div>
          <div className="col-6 p-0">
            <div className="formslabel">Role Name</div>
            <Dropdown
              id="fld_role_name"
              name="fld_role_name"
              placeholder="Select Role"
              className={
                formik.errors.fld_role_name && formik.touched.fld_role_name
                  ? "p-invalid p-inputtext forminputtext-invalid"
                  : "p-inputtext forminputtext"
              }
              options={roleNames}
              value={selectedRole}
              onChange={(e) => {
                const selected = e.value;
                formik.setFieldValue("fld_role_id", selected.id);
                formik.setFieldValue("fld_role_name", selected.label);
                setSelectedRole(selected);

                if (roleID === "2") {
                  getTaluk();

                formik.setFieldValue("taluk_name", "");
                formik.setFieldValue("taluk_code", "");
                formik.setFieldValue("taluk_sw_id", "");


                formik.setFieldValue("village_name", "");
                formik.setFieldValue("village_code", "");
                formik.setFieldValue("village_sw_id", "");
                setSelectedVillage({});
                setVillage([]);
                setSelectedPHC({});
                setPhc([]);
                } else {

                formik.setFieldValue("state_name", "");
                formik.setFieldValue("state_code", "");
                formik.setFieldValue("state_sw_id", "");
                setSelectedState({});
                setState([]);
                getStates();

                formik.setFieldValue("district_name", "");
                formik.setFieldValue("district_code", "");
                formik.setFieldValue("district_sw_id", "");
                setSelectedDistrict({});
                setDistrict([]);

                formik.setFieldValue("site_name", "");
                formik.setFieldValue("site_code", "");
                formik.setFieldValue("site_sw_id", "");
                setSelectedSite({});
                setSite([]);

                formik.setFieldValue("taluk_name", "");
                formik.setFieldValue("taluk_code", "");
                formik.setFieldValue("taluk_sw_id", "");
                setSelectedTaluk({});
                setTaluk([]);

                formik.setFieldValue("village_name", "");
                formik.setFieldValue("village_code", "");
                formik.setFieldValue("village_sw_id", "");
                setSelectedVillage({});
                setVillage([]);
                setSelectedPHC({});
                setPhc([]);
              }
              }}
              disabled={!!editRow}
            />
            {formik.errors.fld_role_name && formik.touched.fld_role_name && (
              <span className="p-error mt-1" style={{ fontSize: "12px" }}>
                {formik.errors.fld_role_name}
              </span>
            )}
          </div>

        </div>

        <div className="grid flex align-items-baseline mt-3 ml-8">
          <div className="col-6 p-0">
            <div className="formslabel">State Name</div>
            <Dropdown
              id="state_name"
              name="state_name"
              placeholder={stateName || "Select State"}
              value={formik.values.state_name}
              className={
                formik.errors.state_name && formik.touched.state_name
                  ? "p-invalid p-inputtext forminputtext-invalid"
                  : "p-inputtext forminputtext"
              }
              options={state}
              
              onChange={(e) => {
                const selectedState = state.find(
                  (stateObj) => stateObj.value === e.value
                );
                setSelectedState(selectedState);
                formik.setFieldValue("state_name", e.value);
                if (selectedState) {
                  formik.setFieldValue("state_code", selectedState.value || "");
                  formik.setFieldValue(
                    "state_sw_id",
                    selectedState.state_swid || ""
                  );
                  getDistrict(
                    selectedState.state_code,
                    selectedState.state_swid
                  );
                } else {
                  formik.setFieldValue("state_code", "");
                  formik.setFieldValue("state_sw_id", "");
                  setDistrict([]);
                }

                formik.setFieldValue("district_name", "");
                formik.setFieldValue("district_code", "");
                formik.setFieldValue("district_sw_id", "");
                setSelectedDistrict({});
                setDistrict([]);

                formik.setFieldValue("site_name", "");
                formik.setFieldValue("site_code", "");
                formik.setFieldValue("site_sw_id", "");
                setSelectedSite({});
                setSite([]);

                formik.setFieldValue("taluk_name", "");
                formik.setFieldValue("taluk_code", "");
                formik.setFieldValue("taluk_sw_id", "");
                setSelectedTaluk({});
                setTaluk([]);

                formik.setFieldValue("village_name", "");
                formik.setFieldValue("village_code", "");
                formik.setFieldValue("village_sw_id", "");
                setSelectedVillage({});
                setVillage([]);
                setSelectedPHC({});
                setPhc([]);

              }}
              disabled={!!editRow || roleID === "2"}

            />
            {formik.errors.state_name && formik.touched.state_name && (
              <span className="p-error mt-1" style={{ fontSize: "12px" }}>
                {formik.errors.state_name}
              </span>
            )}
          </div>
          <div className="col-6 p-0">
            <div className="formslabel">District Name</div>
            <Dropdown
              id="district_name"
              name="district_name"
              placeholder="Select District"
              value={formik.values.district_name}
              className={
                formik.errors.district_name && formik.touched.district_name
                  ? "p-invalid p-inputtext forminputtext-invalid"
                  : "p-inputtext forminputtext"
              }
              options={district}
              onChange={(e) => {
                const selectedDistrict = district.find(
                  (districtObj) => districtObj.value === e.value
                );
                setSelectedDistrict(selectedDistrict);
                formik.setFieldValue("district_name", e.value);

                if (selectedDistrict) {
                  formik.setFieldValue(
                    "district_code",
                    selectedDistrict.district_code || ""
                  );
                  formik.setFieldValue(
                    "district_sw_id",
                    selectedDistrict.district_swid || ""
                  );

                  getSite(
                    selectedState.state_code, // Assuming this holds the selected state_id
                    selectedState.state_swid, // Assuming this holds the selected state_sw_id
                    selectedDistrict.district_code,
                    selectedDistrict.district_swid
                  );
                } else {
                  formik.setFieldValue("district_code", "");
                  formik.setFieldValue("district_sw_id", "");
                  setTaluk([]);
                }

                formik.setFieldValue("site_name", "");
                formik.setFieldValue("site_code", "");
                formik.setFieldValue("site_sw_id", "");
                setSelectedSite({});
                setSite([]);

                formik.setFieldValue("taluk_name", "");
                formik.setFieldValue("taluk_code", "");
                formik.setFieldValue("taluk_sw_id", "");
                setSelectedTaluk({});
                setTaluk([]);

                formik.setFieldValue("village_name", "");
                formik.setFieldValue("village_code", "");
                formik.setFieldValue("village_sw_id", "");
                setSelectedVillage({});
                setVillage([]);
                setSelectedPHC({});
                setPhc([]);

                formik.setFieldValue("phc_name", "");
              }}
              disabled={!!editRow || roleID === "2"}

            />
            {formik.errors.district_name && formik.touched.district_name && (
              <span className="p-error mt-1" style={{ fontSize: "12px" }}>
                {formik.errors.district_name}
              </span>
            )}
          </div>
        </div>

        <div className="grid flex align-items-baseline mt-3 ml-8">
          <div className="col-6 p-0">
            <div className="formslabel">Site Name</div>
            <Dropdown
              id="site_name"
              name="site_name"
              placeholder="Select Site"
              value={formik.values.site_name}
              className={
                formik.errors.site_name && formik.touched.site_name
                  ? "p-invalid p-inputtext forminputtext-invalid"
                  : "p-inputtext forminputtext"
              }
              options={site}
              onChange={(e) => {
                const selectedSite = site.find(
                  (siteObj) => siteObj.value === e.value
                );
                setSelectedSite(selectedSite);
                formik.setFieldValue("site_name", e.value);

                if (selectedSite) {
                  formik.setFieldValue(
                    "site_code",
                    selectedSite.site_code || ""
                  );
                  formik.setFieldValue(
                    "site_sw_id",
                    selectedSite.site_swid || ""
                  );

                  getTaluk(
                    selectedState.state_code, // Assuming this holds the selected state_id
                    selectedState.state_swid, // Assuming this holds the selected state_sw_id
                    selectedDistrict.district_code, // Assuming this holds the selected district_id
                    selectedDistrict.district_swid, // Assuming this holds the selected district_sw_id
                    selectedSite.site_code,
                    selectedSite.site_swid
                  );
                } else {
                  formik.setFieldValue("site_code", "");
                  formik.setFieldValue("site_sw_id", "");
                  setSite([]);
                }

                formik.setFieldValue("taluk_name", "");
                formik.setFieldValue("taluk_code", "");
                formik.setFieldValue("taluk_sw_id", "");
                setSelectedTaluk({});
                setTaluk([]);

                formik.setFieldValue("village_name", "");
                formik.setFieldValue("village_code", "");
                formik.setFieldValue("village_sw_id", "");
                setSelectedVillage({});
                setVillage([]);
                setSelectedPHC({});
                setPhc([]);

                formik.setFieldValue("phc_name", "");
              }}
              disabled={!!editRow || roleID === "2"}

            />
            {formik.errors.site_name && formik.touched.site_name && (
              <span className="p-error mt-1" style={{ fontSize: "12px" }}>
                {formik.errors.site_name}
              </span>
            )}
          </div>
          <div className="col-6 p-0">
            <div className="formslabel">Taluk Name</div>
            <Dropdown
              id="taluk_name"
              name="taluk_name"
              placeholder="Select Taluk"
              value={formik.values.taluk_name}
              className={
                formik.errors.taluk_name && formik.touched.taluk_name
                  ? "p-invalid p-inputtext forminputtext-invalid"
                  : "p-inputtext forminputtext"
              }
              options={taluk}
              onChange={(e) => {
                const selectedTaluk = taluk.find(
                  (talukObj) => talukObj.value === e.value
                );
                setSelectedTaluk(selectedTaluk);
                formik.setFieldValue("taluk_name", e.value);

                if (selectedTaluk) {
                  formik.setFieldValue(
                    "taluk_code",
                    selectedTaluk.taluk_code || ""
                  );
                  formik.setFieldValue(
                    "taluk_sw_id",
                    selectedTaluk.taluk_swid || ""
                  );

                  getVillage(
                    selectedState.state_code, // Assuming this holds the selected state_id
                    selectedState.state_swid, // Assuming this holds the selected state_sw_id
                    selectedDistrict.district_code, // Assuming this holds the selected district_id
                    selectedDistrict.district_swid, // Assuming this holds the selected district_sw_id
                    selectedSite.site_code,
                    selectedSite.site_swid,
                    selectedTaluk.taluk_code,
                    selectedTaluk.taluk_swid
                  );
                } else {
                  formik.setFieldValue("taluk_code", "");
                  formik.setFieldValue("taluk_sw_id", "");
                  setSite([]);
                }

                formik.setFieldValue("village_name", "");
                formik.setFieldValue("village_code", "");
                formik.setFieldValue("village_sw_id", "");
                setSelectedVillage({});
                setVillage([]);
                setSelectedPHC({});
                setPhc([]);

                formik.setFieldValue("phc_name", "");
              }}
              disabled={!!editRow}

            />
            {formik.errors.taluk_name && formik.touched.taluk_name && (
              <span className="p-error mt-1" style={{ fontSize: "12px" }}>
                {formik.errors.taluk_name}
              </span>
            )}
          </div>
        </div>

        <div className="grid flex align-items-baseline mt-3 ml-8">

          <div className="col-6 p-0">
            <div className="formslabel">Village Name</div>
            <Dropdown
              id="village_name"
              name="village_name"
              placeholder="Select Village"
              value={formik.values.village_name}
              className={
                formik.errors.village_name && formik.touched.village_name
                  ? "p-invalid p-inputtext forminputtext-invalid"
                  : "p-inputtext forminputtext"
              }
              options={village}
              onChange={(e) => {
                const selectedVillage = village.find(
                  (villageObj) => villageObj.value === e.value
                );
                setSelectedVillage(selectedVillage);
                formik.setFieldValue("village_name", e.value);
                // console.log("village", village);

                if (selectedVillage) {
                  formik.setFieldValue(
                    "village_code",
                    selectedVillage.village_code || ""
                  );
                  formik.setFieldValue(
                    "village_sw_id",
                    selectedVillage.village_swid || ""
                  );

                  getPHC(
                    selectedState.state_code, // Assuming this holds the selected state_id
                    selectedState.state_swid, // Assuming this holds the selected state_sw_id
                    selectedDistrict.district_code, // Assuming this holds the selected district_id
                    selectedDistrict.district_swid, // Assuming this holds the selected district_sw_id
                    selectedSite.site_code,
                    selectedSite.site_swid,
                    selectedTaluk.taluk_code,
                    selectedTaluk.taluk_swid,
                    selectedVillage.village_code,
                    selectedVillage.village_swid
                  );
                  getReportingPRS(
                    selectedState.state_code, // Assuming this holds the selected state_id
                    selectedState.state_swid, // Assuming this holds the selected state_sw_id
                    selectedDistrict.district_code, // Assuming this holds the selected district_id
                    selectedDistrict.district_swid, // Assuming this holds the selected district_sw_id
                    selectedSite.site_code,
                    selectedSite.site_swid,
                    selectedTaluk.taluk_code,
                    selectedTaluk.taluk_swid,
                    selectedVillage.village_code,
                    selectedVillage.village_swid
                  );
                } else {
                  formik.setFieldValue("village_code", "");
                  formik.setFieldValue("village_sw_id", "");
                  setSite([]);
                }

                formik.setFieldValue("phc_name", "");
              }}
              disabled={!!editRow}

            />
            {formik.errors.village_name && formik.touched.village_name && (
              <span className="p-error mt-1" style={{ fontSize: "12px" }}>
                {formik.errors.village_name}
              </span>
            )}
          </div>
        </div>

        <div className="grid flex align-items-baseline mt-3 ml-8">
          <div className="col-6 p-0">
            <div className=" formslabel">PHC Name</div>
            <Dropdown
              id="phc_name"
              name="phc_name"
              placeholder="Select PHC"
              value={formik.values.phc_name}
              className={
                formik.errors.phc_name && formik.touched.phc_name
                  ? "p-invalid p-inputtext forminputtext-invalid"
                  : "p-inputtext forminputtext"
              }
              options={phc}
              onChange={(e) => {
                const selectedPHC = phc.find(
                  (phcObj) => phcObj.value === e.value
                );
                setSelectedPHC(selectedPHC);
                // console.log("PHC", selectedPHC);
                formik.setFieldValue("phc_name", e.value);

                if (selectedPHC) {
                  formik.setFieldValue("phc_code", selectedPHC.phc_code || "");
                  formik.setFieldValue("phc_sw_id", selectedPHC.phc_swid || "");
                  formik.setFieldValue("phc_type_id", selectedPHC.phc_type_id || "");
                  formik.setFieldValue("phc_type_name", selectedPHC.phc_type_name || "");

                } else {
                  formik.setFieldValue("phc_code", "");
                  formik.setFieldValue("phc_sw_id", "");
                  formik.setFieldValue("phc_type_id", "");
                  formik.setFieldValue("phc_type_name", "");

                }
              }}
              disabled={!!editRow}

            />
            {formik.errors.phc_name && formik.touched.phc_name && (
              <span className="p-error mt-1" style={{ fontSize: "12px" }}>
                {formik.errors.phc_name}
              </span>
            )}
          </div>
        {selectedRole?.id === "4" && (
            <div className="col-6 p-0">
              <div className="formslabel">Reporting PRS</div>
              <Dropdown
                id="fld_reporting_prs_name"
                name="fld_reporting_prs_name"
                placeholder="Select Reporting PRS"
                value={formik.values.fld_reporting_prs_name}
                className={
                  formik.errors.fld_reporting_prs_name &&
                  formik.touched.fld_reporting_prs_name
                    ? "p-invalid p-inputtext forminputtext-invalid"
                    : "p-inputtext forminputtext"
                }
                options={reportingPRS}
                onChange={(e) => {
                  const selectedReportingPRS = reportingPRS.find(
                    (prsObj) => prsObj.value === e.value
                  );
                  setSelectedReportingPRS(selectedReportingPRS);
                  formik.setFieldValue("fld_reporting_prs_name", e.value);

                  if (selectedReportingPRS) {
                    formik.setFieldValue(
                      "fld_reporting_prs_sw_id",
                      selectedReportingPRS.reporting_prs_code || ""
                    );
                  } else {
                    formik.setFieldValue("fld_reporting_prs_sw_id", "");
                    formik.setFieldValue("fld_reporting_prs_name", "");
                  }
                }}
              disabled={!!editRow}

              />
              {formik.errors.fld_reporting_prs_name &&
                formik.touched.fld_reporting_prs_name && (
                  <span className="p-error mt-1" style={{ fontSize: "12px" }}>
                    {formik.errors.fld_reporting_prs_name}
                  </span>
                )}
            </div>
        )}
        </div>
      </div>


      <div className="pb-4 mt-4" style={{border:"1px solid #c2c2c2", borderRadius:"10px", boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)"}}>

      {!editRow && (
        <div className="grid flex align-items-baseline mt-3 ml-8">
          <div className="col-6 p-0">
            <div className="formslabel">Is Replaced</div>
            <Dropdown
              id="fld_is_replaced_name"
              name="fld_is_replaced_name"
              placeholder="Select Is Replaced"
              showClear
              className={
                formik.errors.fld_is_replaced_name && formik.touched.fld_is_replaced_name
                  ? "p-invalid p-inputtext forminputtext-invalid"
                  : "p-inputtext forminputtext"
              }
              options={isReplaced}
              value={selectedIsReplaced}
              onChange={(e) => {
                const selected = e.value;
                if (selected) {
                  formik.setFieldValue("fld_is_replaced_id", selected.id);
                  formik.setFieldValue("fld_is_replaced_name", selected.label);
                  setSelectedIsReplaced(selected);
            
                  if (selected.id === "1") {
                    getReplacedUser(selectedRole, selectedPHC);
                  }
                } else {
                  // Handle the clear case
                  formik.setFieldValue("fld_is_replaced_id", "");
                  formik.setFieldValue("fld_is_replaced_name", "");
                  setSelectedIsReplaced(null);
                  formik.setFieldValue("fld_replaced_user_name", "");
                  setSelectedReplacedUser(null)
                }

              }}
            />
            {formik.errors.fld_is_replaced_name &&
              formik.touched.fld_is_replaced_name && (
                <span className="p-error mt-1" style={{ fontSize: "12px" }}>
                  {formik.errors.fld_is_replaced_name}
                </span>
              )}
          </div>
          <div className="col-6 p-0">
            <div className=" formslabel">Replaced User Name</div>
            <Dropdown
              id="fld_replaced_user_name"
              name="fld_replaced_user_name"
              placeholder="Select Replaced User Name"
              className={
                formik.errors.fld_replaced_user_name && formik.touched.fld_replaced_user_name
                  ? "p-invalid p-inputtext forminputtext-invalid"
                  : "p-inputtext forminputtext"
              }
              options={replacedUser}
              value={formik.values.fld_replaced_user_name}
              onChange={(e) => {
                const selectedReplacedUser = replacedUser.find(
                  (userObj) => userObj.value === e.value
                );

                formik.setFieldValue("fld_replaced_user_name", e.value); // Set the name
                formik.setFieldValue("fld_rf_id", selectedReplacedUser?.rUser_rfID || ""); // RF ID
                formik.setFieldValue("fld_user_sw_id", selectedReplacedUser?.rUser_swid || ""); // SW ID
                formik.setFieldValue("fld_user_id", selectedReplacedUser?.rUser_ID || ""); // User ID
                formik.setFieldValue("fld_password", selectedReplacedUser?.rUser_pass || ""); // Password
                formik.setFieldValue("fld_user_code", selectedReplacedUser?.rUser_code || ""); // User Code
                setSelectedReplacedUser(selectedReplacedUser);
              }}
              disabled={selectedIsReplaced?.id !== "1"} 
            />

            {formik.errors.fld_replaced_user_name && formik.touched.fld_replaced_user_name && (
              <span className="p-error mt-1" style={{ fontSize: "12px" }}>
                {formik.errors.fld_replaced_user_name}
              </span>
            )}
          </div>
        </div>
      )}

        <div className="grid flex align-items-baseline mt-3 ml-8">
          <div className="col-6 p-0">
            <div className=" formslabel">Prior User Name</div>
            <InputText
              id="fld_user_name"
              name="fld_user_name"
              style={{ padding: "10px", fontSize: "14px" }}
              keyfilter={/^[a-zA-Z\s]*$/}
              maxLength={100}
              placeholder="Enter Prior User Name"
              onChange={formik.handleChange}
              value={formik.values.fld_user_name}
              className={
                formik.errors.fld_user_name && formik.touched.fld_user_name
                  ? "p-invalid p-inputtext forminputtext-invalid"
                  : "p-inputtext forminputtext"
              }
            />
            {formik.errors.fld_user_name && formik.touched.fld_user_name && (
              <span className="p-error mt-1" style={{ fontSize: "12px" }}>
                {formik.errors.fld_user_name}
              </span>
            )}
          </div>
          <div className="col-6 p-0">
            <div className=" formslabel">Age</div>
            <InputText
              id="fld_age"
              name="fld_age"
              style={{ padding: "10px", fontSize: "14px" }}
              keyfilter="int"
              maxLength={2}
              placeholder="Enter age"
              onChange={formik.handleChange}
              value={formik.values.fld_age}
              className={
                formik.errors.fld_age && formik.touched.fld_age
                  ? "p-invalid p-inputtext forminputtext-invalid"
                  : "p-inputtext forminputtext"
              }
            />

            {formik.errors.fld_age && formik.touched.fld_age && (
              <span className="p-error mt-1" style={{ fontSize: "12px" }}>
                {formik.errors.fld_age}
              </span>
            )}
          </div>
        </div>

        <div className="grid flex align-items-baseline mt-3 ml-8">
          <div className="col-6 p-0">
            <div className="formslabel">Gender</div>
            <Dropdown
              id="fld_gender_name"
              name="fld_gender_name"
              placeholder="Select gender"
              className={
                formik.errors.fld_gender_name && formik.touched.fld_gender_name
                  ? "p-invalid p-inputtext forminputtext-invalid"
                  : "p-inputtext forminputtext"
              }
              options={genderNames}
              value={selectedGender}
              onChange={(e) => {
                const selected = e.value;
                formik.setFieldValue("fld_gender_id", selected.id);
                formik.setFieldValue("fld_gender_name", selected.label);
                setSelectedGender(selected);
              }}
            />
            {formik.errors.fld_gender_name &&
              formik.touched.fld_gender_name && (
                <span className="p-error mt-1" style={{ fontSize: "12px" }}>
                  {formik.errors.fld_gender_name}
                </span>
              )}
          </div>
          <div className="col-6 p-0">
            <div className=" formslabel">Email ID</div>
            <InputText
              id="fld_email_id"
              name="fld_email_id"
              type="email"
              style={{ padding: "10px", fontSize: "14px" }}
              maxLength={50}
              placeholder="Enter email"
              onChange={formik.handleChange}
              value={formik.values.fld_email_id}
              className={
                formik.errors.fld_email_id && formik.touched.fld_email_id
                  ? "p-invalid p-inputtext forminputtext-invalid"
                  : "p-inputtext forminputtext"
              }
            />

            {formik.errors.fld_email_id && formik.touched.fld_email_id && (
              <span className="p-error mt-1" style={{ fontSize: "12px" }}>
                {formik.errors.fld_email_id}
              </span>
            )}
          </div>
        </div>

        <div className="grid flex align-items-baseline mt-3 ml-8">
          <div className="col-6 p-0">
            <div className=" formslabel">Mobile Number</div>
            <InputText
              id="fld_mobile_number"
              name="fld_mobile_number"
              type="tel"
              style={{ padding: "10px", fontSize: "14px" }}
              keyfilter="int" // Allows only numbers
              maxLength={10}
              minLength={10}
              placeholder="Enter mobile number"
              onChange={formik.handleChange}
              value={formik.values.fld_mobile_number}
              className={
                formik.errors.fld_mobile_number &&
                formik.touched.fld_mobile_number
                  ? "p-invalid p-inputtext forminputtext-invalid"
                  : "p-inputtext forminputtext"
              }
            />

            {formik.errors.fld_mobile_number &&
              formik.touched.fld_mobile_number && (
                <span className="p-error mt-1" style={{ fontSize: "12px" }}>
                  {formik.errors.fld_mobile_number}
                </span>
              )}
          </div>
          <div className="col-6 p-0">
            <div className=" formslabel">AABHA ID</div>
            <InputText
              id="fld_abha_id"
              name="fld_abha_id"
              style={{ padding: "10px", fontSize: "14px" }}
              keyfilter="int"
              minLength={14}
              maxLength={14}
              placeholder="Enter AABHA ID"
              onChange={formik.handleChange}
              value={formik.values.fld_abha_id}
              className={
                formik.errors.fld_abha_id && formik.touched.fld_abha_id
                  ? "p-invalid p-inputtext forminputtext-invalid"
                  : "p-inputtext forminputtext"
              }
            />
            {formik.errors.fld_abha_id && formik.touched.fld_abha_id && (
              <span className="p-error mt-1" style={{ fontSize: "12px" }}>
                {formik.errors.fld_abha_id}
              </span>
            )}
          </div>
        </div>

        <div className="grid flex align-items-baseline mt-3 ml-8">
          <div className="col-6 p-0">
            <div className=" formslabel">Address</div>
            <InputTextarea
              id="fld_address"
              name="fld_address"
              style={{ padding: "10px", fontSize: "14px" }}
              keyfilter={/^[a-zA-Z\s]*$/}
              maxLength={500}
              placeholder="Enter address"
              onChange={formik.handleChange}
              value={formik.values.fld_address}
              className={
                formik.errors.fld_address && formik.touched.fld_address
                  ? "p-invalid p-inputtext forminputtext-invalid"
                  : "p-inputtext forminputtext"
              }
            />
            {formik.errors.fld_address && formik.touched.fld_address && (
              <span className="p-error mt-1" style={{ fontSize: "12px" }}>
                {formik.errors.fld_address}
              </span>
            )}
          </div>

          {editRow && (
          <div className="col-6 p-0">
            <div className="formslabel">Date Of Leaving</div>
            <Calendar
          id="fld_date_of_leaving"
          name="fld_date_of_leaving"
          placeholder=" Date Of Leaving"
          value={formik.values.fld_date_of_leaving}
          onChange={(e) => {
            const selectedDate = e.value instanceof Date ? e.value : new Date(e.value);
            formik.setFieldValue("fld_date_of_leaving", selectedDate);
          }}
          showIcon
          className={
            formik.errors.fld_date_of_leaving && formik.touched.fld_date_of_leaving
                  ? "p-invalid p-inputtext forminputtext-invalid"
                  : "p-inputtext forminputtext"
          }
          dateFormat="dd/mm/yy"
          style={{border:"none"}}
          minDate={formik.values.date || new Date("2021-01-01")}

          maxDate={maxDate}
        />
            {formik.errors.fld_date_of_leaving && formik.touched.fld_date_of_leaving && (
              <span className="p-error mt-1" style={{ fontSize: "12px" }}>
                {formik.errors.fld_date_of_leaving}
              </span>
            )}
          </div>
          )}
        </div>

        {editRow && (
        <div className="grid flex align-items-baseline mt-3 ml-8">
          <div className="col-6 p-0">
            <div className=" formslabel">Reason For Leaving</div>
            <InputTextarea
              id="fld_reason_for_leaving"
              name="fld_reason_for_leaving"
              style={{ padding: "10px", fontSize: "14px" }}
              keyfilter={/^[a-zA-Z\s]*$/}
              maxLength={500}
              placeholder="Enter Reason For Leaving"
              onChange={formik.handleChange}
              value={formik.values.fld_reason_for_leaving}
              className={
                formik.errors.fld_reason_for_leaving && formik.touched.fld_reason_for_leaving
                  ? "p-invalid p-inputtext forminputtext-invalid"
                  : "p-inputtext forminputtext"
              }
            />
            {formik.errors.fld_reason_for_leaving && formik.touched.fld_reason_for_leaving && (
              <span className="p-error mt-1" style={{ fontSize: "12px" }}>
                {formik.errors.fld_reason_for_leaving}
              </span>
            )}
          </div>

        </div>
        )}
      </div>

        <div className="grid flex justify-content-center mt-5">
            <Button type="submit" className="formbutton">
              Submit
            </Button>
        </div>
      </form>

      
      <div  style={{ marginTop: "30px" }}>
        <DataTable
          value={filteredData}
          scrollHeight="350px"
          paginator
          rows={10}
          rowsPerPageOptions={[5, 10, 25, 50]}
          header={header}
          ref={dt}
          scrollable
        >
          <Column
            body={actionBodyTemplate}
            style={{ minWidth: "1rem" }}
            header="Edit"
          />
          <Column field="slno" header="Sl.No" />
          <Column field="fld_phc_name" header="PHC Name"></Column>
          <Column field="fld_date_of_joining" header="Date of joining"></Column>
          <Column field="fld_user_name" header="User Name"></Column>
          <Column field="fld_age" header="Age"></Column>
          <Column field="fld_gender_name" header="Gender"></Column>
          <Column field="fld_email_id" header="Email ID"></Column>
          <Column field="fld_mobile_number" header="Mobile number"></Column>
          <Column field="fld_user_id" header="User ID"></Column>
          <Column field="fld_password" header="Password"></Column>
        </DataTable>
      </div>
    </div>
  );
};

export default UserMaster;
